'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // NPM


var DefinitionList = function (_PureComponent) {
  _inherits(DefinitionList, _PureComponent);

  function DefinitionList() {
    _classCallCheck(this, DefinitionList);

    return _possibleConstructorReturn(this, (DefinitionList.__proto__ || Object.getPrototypeOf(DefinitionList)).apply(this, arguments));
  }

  _createClass(DefinitionList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          definitionList = _props.definitionList,
          className = _props.className;

      return _react2.default.createElement(
        'dl',
        { className: className },
        definitionList.map(function (listItem, i) {
          return _react2.default.createElement(
            _react2.default.Fragment,
            { key: i },
            _react2.default.createElement(
              'dt',
              null,
              listItem.term
            ),
            _react2.default.createElement(
              'dd',
              null,
              listItem.definition
            )
          );
        })
      );
    }
  }]);

  return DefinitionList;
}(_react.PureComponent);

DefinitionList.propTypes = {
  definitionList: _propTypes2.default.array.isRequired
};

DefinitionList.defaultProps = {
  className: ''
};

exports.default = DefinitionList;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Utility/FixtureRenderers/DefinitionList.js
// module id = 608
// module chunks = 0